import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables'
import axios from 'axios';

const API_URL = global.SET_API_URL + 'sr/'

export const getSalesByTypeReport = createAsyncThunk('sbt/gsbtr', async (targetedData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getSalesByTypeReport', targetedData);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    return thunkAPI.rejectWithValue(message)
  }
});

export const getFilteredSalesByTypeReport = createAsyncThunk('sbt/gfsbtr', async (targetedData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getFilteredSalesByTypeReport', targetedData);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    return thunkAPI.rejectWithValue(message)
  }
});

export const getSalesByTypeReportForOpening = createAsyncThunk('sbt/gsbtro', async (targetedData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getSalesByTypeReportForOpening', targetedData);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    return thunkAPI.rejectWithValue(message)
  }
});

const salesByTypeSlice = createSlice({
  name: 'salesByType',
  initialState: {
    reportData: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSalesByTypeReport.fulfilled, (state, action) => {
        state.reportData = action.payload;
      })
      .addCase(getFilteredSalesByTypeReport.fulfilled, (state, action) => {
        state.reportData = action.payload;
      })
      .addCase(getSalesByTypeReportForOpening.fulfilled, (state, action) => {
        state.reportData = action.payload;
      })
  }
});

export default salesByTypeSlice.reducer;
